import script from "./FundDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./FundDetail.vue?vue&type=script&lang=ts&setup=true"

import "./FundDetail.vue?vue&type=style&index=0&id=7461a863&lang=css"
import "./FundDetail.vue?vue&type=style&index=1&id=7461a863&scoped=true&lang=scss"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/webtrade_prod_deploy/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7461a863"]])

export default __exports__